(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LicenceStatistics
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('LicenceStatistics', LicenceStatistics);

  function LicenceStatistics($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/statistics/licences');
  }
}());
